import request from "@/utils/request";

// 文字识别接口
export default function convertTheDocumentToText(data) {
  return request({
    url: `/common/imgUtil/convertTheDocumentToText`,
    method: "post",
    data,
  });
}
